import { render, staticRenderFns } from "./presales.vue?vue&type=template&id=508a95b6&scoped=true&"
import script from "./presales.vue?vue&type=script&lang=js&"
export * from "./presales.vue?vue&type=script&lang=js&"
import style0 from "./presales.vue?vue&type=style&index=0&id=508a95b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508a95b6",
  null
  
)

export default component.exports